module.exports = __webpack_public_path__ + "media/images/assign-2dc3bf44.svg";